import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronUp,
  faChevronDown,
  faMessagesQuestion,
} from '@fortawesome/pro-solid-svg-icons';

/**
 * FAQ component
 * @param {{ items: { question: string; answer: string }[]; language: string }} props
 */
export default function FAQ({ items, language }) {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggle = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  // Texto del título según el idioma
  const titleText =
    language === 'en' ? 'Frequently Asked Questions' : 'Preguntas Frecuentes';

  return (
    <section
      style={{
        padding: '50px 20px',
        backgroundColor: '#fff',
        textAlign: 'center',
      }}
    >
      <h3
        style={{
          fontSize: '36px',
          color: '#333',
          marginBottom: '30px',
          fontWeight: 400,
          display: 'inline-flex',
          alignItems: 'center',
        }}
      >
        <FontAwesomeIcon
          icon={faMessagesQuestion}
          style={{ marginRight: '30px' }}
        />
        {titleText}
      </h3>
      {items.map((item, idx) => (
        <div
          key={idx}
          style={{
            maxWidth: '800px',
            margin: '0 auto 20px',
            textAlign: 'left',
            borderBottom: '1px solid #e0e0e0',
            paddingBottom: '15px',
          }}
        >
          <div
            onClick={() => toggle(idx)}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              fontSize: '18px',
              color: '#333',
              cursor: 'pointer',
              fontWeight: 400,
            }}
          >
            <span>{item.question}</span>
            <FontAwesomeIcon
              icon={expandedIndex === idx ? faChevronUp : faChevronDown}
            />
          </div>
          {expandedIndex === idx && (
            <p
              style={{
                fontSize: '16px',
                color: '#666',
                marginTop: '10px',
                lineHeight: 1.6,
                fontWeight: 400,
              }}
            >
              {item.answer}
            </p>
          )}
        </div>
      ))}
    </section>
  );
}
